import { gql } from '@apollo/client';

// ===== Figure Mutations =====
export const CREATE_FIGURE = gql`
  mutation CreateFigure($input: CreateFigureInput!) {
    createFigure(input: $input) {
      id
      pageId
      x1
      y1
      x2
      y2
      type
    }
  }
`;

export const DELETE_FIGURE = gql`
  mutation DeleteFigure($input: DeleteFigureInput!) {
    deleteFigure(input: $input) {
      id
    }
  }
`;

// ===== Publication Mutations =====
export const CREATE_PUBLICATION = gql`
  mutation CreatePublication($input: CreatePublicationInput!) {
    createPublication(input: $input) {
      id
      title
      author
      year
      public
      license
      createdAt
    }
  }
`;

export const UPDATE_PUBLICATION = gql`
  mutation UpdatePublication($input: UpdatePublicationInput!) {
    updatePublication(input: $input) {
      id
      title
      author
      year
      public
      license
      createdAt
    }
  }
`;

export const DELETE_PUBLICATION = gql`
  mutation DeletePublication($input: DeletePublicationInput!) {
    deletePublication(input: $input) {
      publication {
        id
        __typename
      }
    }
  }
`;

// ===== Grave Mutations =====
export const CREATE_GRAVE = gql`
  mutation CreateGrave($input: CreateGraveInput!) {
    createGrave(input: $input) {
      id
      identifier
      siteId
      depositionType
      verified
      disturbed
    }
  }
`;

export const UPDATE_GRAVE = gql`
  mutation UpdateGrave($input: UpdateGraveInput!) {
    updateGrave(input: $input) {
      id
      identifier
      siteId
      depositionType
      internmentType
      verified
      disturbed
    }
  }
`;

export const DELETE_GRAVE = gql`
  mutation DeleteGrave($input: DeleteGraveInput!) {
    deleteGrave(input: $input) {
      id
    }
  }
`;

export const UPDATE_GRAVE_TAGS = gql`
  mutation UpdateGraveTags($input: UpdateGraveTagsInput!) {
    updateGraveTags(input: $input) {
      id
      tags {
        id
        name
      }
    }
  }
`;

export const UPDATE_GRAVE_SCALE = gql`
  mutation UpdateGraveScale($input: UpdateGraveScaleInput!) {
    updateGraveScale(input: $input) {
      id
      percentageScale
      pageSize
      scale {
        id
        text
      }
    }
  }
`;

export const UPDATE_SKELETON_FIGURE = gql`
  mutation UpdateSkeletonFigure($input: UpdateSkeletonFigureInput!) {
    updateSkeletonFigure(input: $input) {
      id
      depositionType
    }
  }
`;

export const UPDATE_ARROW = gql`
  mutation UpdateArrow($input: UpdateArrowInput!) {
    updateArrow(input: $input) {
      id
      angle
    }
  }
`;

export const RECALCULATE_GRAVE = gql`
  mutation RecalculateGrave($input: RecalculateGraveInput!) {
    recalculateGrave(input: $input) {
      id
      area
      perimeter
      width
      height
      angle
      realWorldArea
      realWorldWidth
      realWorldHeight
      realWorldPerimeter
      figures {
        id
        type
        x1
        y1
        x2
        y2
        area
        perimeter
        width
        height
        angle
        depositionType
      }
      arrow {
        id
        angle
      }
      skeletonFigures {
        id
        depositionType
      }
    }
  }
`;

// ===== Figure Mutations =====
export const UPDATE_FIGURE = gql`
  mutation UpdateFigure($input: UpdateFigureInput!) {
    updateFigure(input: $input) {
      id
      type
      identifier
      siteId
      x1
      y1
      x2
      y2
      angle
      verified
      disturbed
      manualBoundingBox
      boundingBoxAngle
      boundingBoxWidth
      boundingBoxHeight
      controlPoint1X
      controlPoint1Y
      controlPoint2X
      controlPoint2Y
      controlPoint3X
      controlPoint3Y
      controlPoint4X
      controlPoint4Y
      anchorPoint1X
      anchorPoint1Y
      anchorPoint2X
      anchorPoint2Y
      anchorPoint3X
      anchorPoint3Y
      anchorPoint4X
      anchorPoint4Y
    }
  }
`;

export const UPDATE_FIGURE_TAGS = gql`
  mutation UpdateFigureTags($input: UpdateFigureTagsInput!) {
    updateFigureTags(input: $input) {
      id
      tags {
        id
        name
      }
    }
  }
`;

export const UPDATE_FIGURE_SCALE = gql`
  mutation UpdateFigureScale($input: UpdateFigureScaleInput!) {
    updateFigureScale(input: $input) {
      id
      percentageScale
      pageSize
      scale {
        id
        text
      }
    }
  }
`;

export const UPDATE_SCALE_CONTOUR = gql`
  mutation UpdateScaleContour($id: ID!, $points: [[Int!]!]!) {
    updateScaleContour(input: { id: $id, points: $points }) {
      id
      contour
    }
  }
`;

// ===== Site Mutations =====
export const CREATE_SITE = gql`
  mutation CreateSite($input: CreateSiteInput!) {
    createSite(input: $input) {
      id
      name
      lat
      lon
    }
  }
`;

export const UPDATE_SITE = gql`
  mutation UpdateSite($input: UpdateSiteInput!) {
    updateSite(input: $input) {
      id
      name
      lat
      lon
    }
  }
`;

export const DELETE_SITE = gql`
  mutation DeleteSite($input: DeleteSiteInput!) {
    deleteSite(input: $input) {
      id
    }
  }
`;

// ===== User Mutations =====
export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      name
      email
      role
      role
      disabled
    }
  }
`;

// ===== Team Mutations =====
export const CREATE_TEAM = gql`
  mutation CreateTeam($input: CreateTeamInput!) {
    createTeam(input: $input) {
      id
      name
      description
    }
  }
`;

export const UPDATE_TEAM = gql`
  mutation UpdateTeam($input: UpdateTeamInput!) {
    updateTeam(input: $input) {
      id
      name
      description
    }
  }
`;

export const DELETE_TEAM = gql`
  mutation DeleteTeam($input: DeleteTeamInput!) {
    deleteTeam(input: $input) {
      id
    }
  }
`;

export const ADD_TEAM_MEMBER = gql`
  mutation AddTeamMember($teamId: ID!, $userId: ID!) {
    addTeamMember(teamId: $teamId, userId: $userId) {
      id
      userTeams {
        id
        userId
      }
    }
  }
`;

export const REMOVE_TEAM_MEMBER = gql`
  mutation RemoveTeamMember($teamId: ID!, $membershipId: ID!) {
    removeTeamMember(teamId: $teamId, membershipId: $membershipId) {
      id
      userTeams {
        id
        userId
      }
    }
  }
`;

export const ADD_TEAM_PUBLICATION = gql`
  mutation AddTeamPublication($teamId: ID!, $publicationId: ID!) {
    addTeamPublication(teamId: $teamId, publicationId: $publicationId) {
      id
      publicationTeams {
        id
        publicationId
      }
    }
  }
`;

export const REMOVE_TEAM_PUBLICATION = gql`
  mutation RemoveTeamPublication($teamId: ID!, $assignmentId: ID!) {
    removeTeamPublication(teamId: $teamId, assignmentId: $assignmentId) {
      id
      publicationTeams {
        id
        publicationId
      }
    }
  }
`;

// ===== Tag Mutations =====
export const CREATE_TAG = gql`
  mutation CreateTag($input: CreateTagInput!) {
    createTag(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_TAG = gql`
  mutation UpdateTag($input: UpdateTagInput!) {
    updateTag(input: $input) {
      id
      name
    }
  }
`;

export const DELETE_TAG = gql`
  mutation DeleteTag($input: DeleteTagInput!) {
    deleteTag(input: $input) {
      id
    }
  }
`;

// ===== Kiosk (legacy POST /kiosk_configs/kiosk_config.json folded into GraphQL) =====

export const UPDATE_KIOSK_CONFIG = gql`
  mutation UpdateKioskConfig($pageId: ID!, $figureId: ID!) {
    updateKioskConfig(pageId: $pageId, figureId: $figureId) {
      success
      errors
      kioskConfig {
        id
        pageId
        figureId
      }
    }
  }
`;

export const SAVE_RELATED = gql`
  mutation SaveRelated($input: SaveRelatedInput!) {
    saveRelated(input: $input) {
      grave {
        id
        goods {
          id
          artefacts {
            id
          }
          ceramics {
            id
          }
          lithics {
            id
          }
        }
      }
    }
  }
`;
